<div class="desktop-full-screen-overlay--flex payment-dialog" >
  <div>
    <app-form-container [title]="'webPos.BenefitsPaymentTitle' | translate" class="sale-trip__dialog-form-container" (onCancel)="onCancel()" (onSubmit)="onSubmit()"
      [confirmDisabled]="confirmForm.invalid || isBenefitFormInvalid()"
      [additionalActionText]="canOpenOfflinePayment ? 'webPos.OfflinePayment' : null"
      [additionalActionDisabled]="confirmForm.invalid || isBenefitFormInvalid()"
      (onAdditionalAction)="onOfflinePayment()">
      <ng-container form-body [formGroup]="confirmForm">
        <div class="sale-trip__dialog-pay-form">
          @if (data.remainingToPay !== null && data.remainingToPay !== undefined) {
          <div class="sale-trip__dialog-pay-value">
            <span> {{ "webPos.LeftToPay" | translate }}: {{ data.remainingToPay | hcurrency }} </span>
          </div>
          }
          
          <div class="sale-trip__dialog-pay-value">
            <span> {{ "webPos.MaxBenefitPayment" | translate }}: {{ displayedMaxBenefitPaymentValue | hcurrency:'':false:true }}</span>
          </div>

          <!-- Pre-filter dropdown -->
          <app-dropdown [options]="preFilterOptions" [label]="'webPos.PaymentType' | translate"
            [placeholder]="'webPos.SelectPayment' | translate"
            formControlName="preFilter"
            class="sale-trip__dialog-pay-form-dropdown">
          </app-dropdown>

          <!-- Benefits dropdown - only show if pre-filter is selected -->
          @if (selectedPreFilter !== null) {
            <app-dropdown [options]="benefitsOptions" [label]="'webPos.Benefits' | translate"
              [placeholder]="'webPos.ChooseBenefitCompany' | translate"
              formControlName="selectedBenefit"
              class="sale-trip__dialog-pay-form-dropdown">
            </app-dropdown>
          }

          @if (benefitImageUrl; as imageUrl) {
            <img
              class="benefit-payment-dialog__image"
              [src]="imageUrl"
              [attr.alt]="paymentType?.Description || paymentType?.Name || ''"
              (error)="onBenefitImageError(imageUrl)" />
          }

          <div *ngIf="selectedBenefitType == tenderTypes.Virtual">
            <app-action-button class="form__content-inline-btn" [buttonSize]="ActionButtonSize.Smaller" (clicked)="openExternalPage()">
              {{ 'webPos.OpenBenefityLink' | translate }} &nbsp;&nbsp; <fa-icon class="card-button__icon" [icon]="'arrow-up-right-from-square'"></fa-icon>
            </app-action-button>
            <app-form-input [label]="'webPos.ConfirmationCode' | translate" [placeholder]="'webPos.ConfirmationCode' | translate"
              [type]="FormInputType.Text" [value]="" formControlName="confirmationCode">
            </app-form-input>
          </div>
          <div *ngIf="selectedBenefitType == tenderTypes.ElectronicVoucher || selectedBenefitType == tenderTypes.Virtual">
            <app-form-input [label]="'webPos.ValueToPay' | translate" [placeholder]="'webPos.ValueToPay' | translate"
              [type]="FormInputType.Number" [value]="" formControlName="valueToPay">
            </app-form-input>
          </div>
          <div *ngIf="selectedBenefitType == tenderTypes.Cheque" class="nominals-container">
            <!-- If there are denominals available, show the rows form -->
            <div *ngIf="selectedBenefitTypeNominalsOption && selectedBenefitTypeNominalsOption.length > 0" [formGroup]="confirmForm.controls.voucherRowsGroup">
              <div formArrayName="rows" id="voucherRows" class="sale-trip__dialog-pay-form-row-container" #scrollContainer>
                <div *ngFor="let rowCtrl of rows.controls; let i = index" class="sale-trip__dialog-pay-form-row" [formGroupName]="i">
                  <div class="sale-trip__dialog-pay-form-row-counter">
                    <span> {{ i + 1 }}. </span>
                  </div>
                  <app-dropdown class="sale-trip__dialog-pay-form-row--value" [label]="'webPos.Value' | translate" [options]="selectedBenefitTypeNominalsOption" formControlName="value">
                  </app-dropdown>

                  <app-form-input class="sale-trip__dialog-pay-form-row--pieces" [label]="'webPos.CountOfPieces' | translate" [type]="FormInputType.Number" formControlName="numberOfItems">
                  </app-form-input>

                  <div class="sale-trip__dialog-pay-form-row-add-button">
                    <fa-icon [icon]="['fas', 'circle-plus']" (click)="addRow()"></fa-icon>
                  </div>
                  <div class="sale-trip__dialog-pay-form-row-delete-button" [class.sale-trip__dialog-pay-form-row-delete-button--disabled]="rows.length <= 1">
                    <fa-icon [icon]="['fas', 'trash']" (click)="removeRow(i)"></fa-icon>
                  </div>
                </div>
              </div>
              <div class="sale-trip__dialog-pay-form-footer">
                <div>
                  <span>{{ "webPos.TotalBenefitValue" | translate }}:</span>
                </div>
                <div class="sale-trip__dialog-pay-form-total-value">
                  <span> {{ getTotalPaperValue() | hcurrency}} </span>
                </div>
              </div>
            </div>
            <!-- If no denominals available, show simple value and number inputs -->
            <div *ngIf="!selectedBenefitTypeNominalsOption || selectedBenefitTypeNominalsOption.length === 0">
              <app-form-input [label]="'webPos.ValueToPay' | translate" [placeholder]="'webPos.ValueToPay' | translate"
                [type]="FormInputType.Number" [value]="" formControlName="valueToPay">
              </app-form-input>
              <app-form-input [label]="'webPos.VoucherCode' | translate" [placeholder]="'webPos.VoucherCode' | translate"
                [type]="FormInputType.Text" formControlName="voucherCode">
              </app-form-input>
            </div>
          </div>

          @if (hasOverpaymentOverrideError('valueToPay', ['maxAllowedExceeded', 'maxValueExceeded'])) {
          <div class="dialog__error">
            <span>{{ 'webPos.Errors.MaxAllowedAmountExceeded' | translate }}</span>
          </div>
          }

          @if (shouldShowOverpaymentOverride('valueToPay', ['maxAllowedExceeded', 'maxValueExceeded'])) {
          <div class="dialog__checkbox-container">
            <input type="checkbox" id="AllowOverpaymentBenefitCheckbox" class="dialog__checkbox" formControlName="allowOverpayment" />
            <label for="AllowOverpaymentBenefitCheckbox" class="dialog__checkbox-label">{{ 'webPos.AllowOverpayment' | translate }}</label>
          </div>
          }

          @if (isOverpaymentOverrideEnabled()) {
          <app-form-input [label]="'webPos.OverpaymentReason' | translate" [placeholder]="'webPos.OverpaymentReasonPlaceholder' | translate"
            [type]="FormInputType.Textarea" formControlName="overpaymentReason" [maxLength]="500">
          </app-form-input>
          }

        </div>
      </ng-container>
    </app-form-container>
  </div> 
</div>
